import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  backdrop: {
    zIndex: 5000,
    color: '#fff',
  },
});

const Loader = (props) => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={props.open}>
      {props.msg ? (
        <div>{props.msg}</div>
      ) : (
        <CircularProgress color="inherit" />
      )}
    </Backdrop>
  );
};

export default Loader;
